import './Error.scss';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

// General Error Component
const Error = ({ errorMessages, errorTitle, type }) => {
  return (
    <div className={`error_container ${type}`} data-testid="error_message">
      {(type == 'info' || type == 'expected_bay') && (
        <FontAwesomeIcon className="symbol" icon={faCircleInfo} data-testid="info_icon" />
      )}
      <div className="error_content">
        {errorTitle && <div className="error_title">{errorTitle}</div>}
        {Array.isArray(errorMessages) ? (
          errorMessages.map((errorMessage, i) => {
            return (
              <div key={i} className={`error_message ${errorTitle ? 'shifted' : ''}`}>
                <span className="bulletpoint">{errorTitle ? '•' : ''}</span>
                {errorMessage.split('[')[0]}
              </div>
            );
          })
        ) : (
          <div className={`error_message ${errorTitle ? 'shifted' : ''}`}>
            <span className="bulletpoint">{errorTitle ? '•' : ''}</span>
            {errorMessages.split('[')[0]}
          </div>
        )}
      </div>
    </div>
  );
};

Error.propTypes = {
  errorMessages: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  errorTitle: PropTypes.string,
  type: PropTypes.string,
};

export default Error;
